import React from "react";
import { IconButton } from "@mui/material";
import InnoIcons from "@InnoIcons/";

const LeftCollapsedButton = ({ onClick }) => {
  return (
    <div
      style={{
        position: "absolute",
        left: -46,
        top: 0,
        zIndex: 40,
        width: 46,
        height: 46,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FFF9E5",
        borderRadius: "5px 0 0 5px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      <IconButton
        size="small"
        onClick={onClick}
        aria-label="open-summary"
        sx={{ color: "black" }}
      >
        <InnoIcons.KeyboardDoubleArrowLeftIcon
          sx={{ fontSize: 28, color: "black" }}
        />
      </IconButton>
    </div>
  );
};

export default LeftCollapsedButton;
